export default {
  data () {
    return {
      results: [],
      value:'',
      allDiseases: [],
      searchDisease: [],
      showResult: false,
      tips: '空空如也~',
      showLoading: false,
      content: '',
      orgUid: '',
      orgInfo: {}
    }
  },
  computed:{
    template(){
      return this.$route.meta.template;
    }
  },
  methods:{
    getResult (val) {
      console.log('on-change', val)
      if (val) {
        let url = 'disease/search/' + this.value + '/0/30?orgUid=' + this.orgUid;
        this.$http.get(url, null,(res) => {
          console.log(res);
          this.searchDisease = res.data;
        }, (error) => {
          console.log(error);
        });
      } else {
        this.searchDisease = [];
        this.tips = '空空如也~'
      }
    },
    onSubmit () {
      this.$refs.search.setBlur()
      if (this.searchDisease.length === 0) {
        this.tips = '检索不到相关的内容...'
      }
    },
    onFocus () {
      this.showResult = true
      this.tips = '空空如也~'
      setTimeout(function(){
        document.body.scrollTop = 0;
      }, 50);
    },
    onCancel () {
      this.showResult = false
    },
    getAllDisease() {
      this.loading(true,'');
      let url = 'department/all/' + this.orgUid;
      this.$http.get(url, null,(res) => {
        this.loading(false, '');
        console.log(res);
        this.allDiseases = res.data;
      }, (error) => {
        this.loading(false, '');
        console.log(error);
      });
    },
    chat(cnName, enName, id) {
      console.log(cnName);
      this.$router.push({path: `/${this.template}/chat/${this.orgUid}`, query: {cnName: cnName, enName: enName, id: id}});
    },
    loading(show, content) {
      this.showLoading = show;
      this.content = content;
    },
    getOrganization(){
      let url = 'organization/' + this.orgUid;
      this.$http.get(url, null,(res) => {
        console.log(res);
        this.orgInfo = res.data;
        this.$route.meta.title = this.orgInfo.name + '智能问答';
      }, () => {
        this.alert('连接不上服务器，请检查网络')
      });
    }
  },
  mounted () {
    this.orgUid = this.$route.params.orgUid;
    this.getOrganization();
    this.getAllDisease()
  }
}



// WEBPACK FOOTER //
// ./src/views/mixins/SearchMixin.js